import script from "./AccountChart.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountChart.vue?vue&type=script&setup=true&lang=js"

import "./AccountChart.vue?vue&type=style&index=0&id=54bd9544&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54bd9544"]])

export default __exports__